import { render, staticRenderFns } from "./CheckoutPayment.vue?vue&type=template&id=2ed86122&scoped=true&"
import script from "./CheckoutPayment.vue?vue&type=script&lang=js&"
export * from "./CheckoutPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed86122",
  null
  
)

export default component.exports